var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canCancel(_vm.account, _vm.schoolList))?_c('BaseFlow',{attrs:{"icon":"fas fa-times","type":"danger"},on:{"click":_vm.cancelList}},[_vm._v(" Annuler la liste ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }